import type { HomepageConfig, FeaturedWork as FeaturedWorkItem } from '@cng/shared';
import { SmartImage, SmartVideo } from '@/components/common/SmartImage';

interface FeaturedWorkProps {
  config: HomepageConfig['featuredWork'];
  items: FeaturedWorkItem[];
}

/** The horizontally scrolling "Real Transformations" video row. */
export function FeaturedWork({ config, items }: FeaturedWorkProps) {
  if (!config?.enabled || items.length === 0) return null;

  return (
    <section className="fans-section" aria-labelledby="featured-work-title">
      <h2 className="fans-title" id="featured-work-title">
        {config.title}
        {config.titleAccent ? <> <span>{config.titleAccent}</span></> : null}
      </h2>

      <div className="fans-carousel" role="list">
        {items.map((item) => (
          <div className="fan-card" role="listitem" key={item._id}>
            <div className="video-container">
              {item.video?.url ? (
                <SmartVideo
                  media={item.video}
                  autoPlay={false}
                  controls
                  loop={false}
                  poster={item.image?.url ?? null}
                  ariaLabel={`${item.title} — ${item.category}`}
                />
              ) : (
                <SmartImage media={item.image} alt={item.image?.alt || item.title} sizes="280px" />
              )}
              <div className="product-badge">
                {item.label ? <div className="badge-label">{item.label}</div> : null}
                {item.category ? <div className="badge-title">{item.category}</div> : null}

              </div>
            </div>
            <div className="card-footer">
              <h3>{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
